export const isObject = (value: any): value is Record<string, any> =>
  value !== null && typeof value === "object" && !Array.isArray(value);

export const asString = (value: any): string | undefined => {
  if (value === null || value === undefined) return undefined;
  return String(value);
};

export const asNumber = (value: any): number | undefined => {
  if (value === null || value === undefined || value === "") return undefined;
  const numberValue = Number(value);
  return Number.isNaN(numberValue) ? undefined : numberValue;
};

export const asBoolean = (value: any): boolean | undefined => {
  if (value === null || value === undefined) return undefined;
  if (typeof value === "boolean") return value;
  if (typeof value === "string") {
    const normalized = value.toLowerCase();
    if (normalized === "true") return true;
    if (normalized === "false") return false;
  }
  return Boolean(value);
};

export const asDate = (value: any): Date | undefined => {
  if (!value) return undefined;
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? undefined : date;
};

export const asArray = (value: any): any[] =>
  Array.isArray(value) ? value : [];

export const parseList = (value: any, parser: (item: any) => any): any[] =>
  asArray(value).map((item) => parser(item));
